module.exports = __webpack_public_path__ + "img/docs-templates.739cb227.jpg";